import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <>
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/image/clean7.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "350px", // or any desired height
          display: "flex",
          alignItems: "flex-end", // this pushes content to the bottom
          paddingBottom: "30px", // space from bottom edge
        }}
      >
        <div className="container mt-5">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">404 ERROR</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>404 ERROR</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="error-page text-center">
                <div className="error-content">
                  <div className="error-img mb-50">
                    <img
                      src="/assets/img/normal/error.png"
                      alt="404 img"
                      width={300}
                      height={300}
                    />
                  </div>
                  <h2 className="error-title mb-20">
                    <span className="text-theme">OooPs!</span> Page Not Found
                  </h2>
                  <p className="error-text mb-30">
                    Oops! The page you are looking for does not exist. It might
                    have been moved or deleted.
                  </p>
                  <Link to="/" className="th-btn">
                    <i className="fa-solid fa-home me-2"></i> Back To Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
